/**
 * @fileoverview Shared locale detection for all pages.
 * Import `currentLang` wherever a locale-aware string is needed.
 */

export type SupportedLang = 'en' | 'de' | 'es' | 'fr' | 'pt' | 'bs';

export const supportedLangs: Record<SupportedLang, string> = {
    en: 'English',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
    pt: 'Português',
    bs: 'Bosanski',
};

const SUPPORTED: SupportedLang[] = ['de', 'es', 'fr', 'pt', 'bs'];

function getStoredLang(): SupportedLang | null {
    const stored = localStorage.getItem('toddler-game-lang');
    return stored as SupportedLang | null;
}

export function setLang(lang: string): void {
    if (Object.keys(supportedLangs).includes(lang)) {
        localStorage.setItem('toddler-game-lang', lang);
    }
}

function detectLang(): SupportedLang {
    const storedLang = getStoredLang();
    if (storedLang) {
        return storedLang;
    }
    // navigator.language is always the browser/OS language regardless of URL.
    // Examples: 'de', 'de-DE', 'de-AT' → 'de'
    const code = navigator.language.slice(0, 2).toLowerCase() as SupportedLang;
    return SUPPORTED.includes(code) ? code : 'en';
}

/** Current locale, derived from the browser language setting. */
export const currentLang: SupportedLang = detectLang();
